<template>
  <div class="clinic-list">
    <van-sticky>
      <van-search
        v-model="keyword"
        placeholder="请输入关键词搜索"
        @search="onSearch"
        background="transparent"
        shape="round"
      >
      </van-search>
      <van-dropdown-menu>
        <van-dropdown-item
          v-for="(item, index) in filter.slice(0, 4)"
          ref="searchFilterFormItems"
          :key="item.id"
        >
          <p
            slot="title"
            :class="
              filterActionsActiveClass(item)
                ? 'search-filter-form-item-active'
                : ''
            "
          >
            {{ item.name }}
          </p>
          <div style="max-height: 50vh;overflow-y: auto;">
            <p class="search-filter-form-all-title">{{ item.name }}</p>
            <div class="search-filter-form-list">
              <van-button
                type="default"
                size="small"
                round
                @click="handleAllFilterClick(item.children)"
                :class="
                  filterActionsActive(item)
                    ? 'search-filter-form-item-active'
                    : 'search-filter-form-item'
                "
                :color="
                  filterActionsActive(item) ? '#E5FCFA' : '#F1F2F4'
                "
              >
                全部
              </van-button>
              <van-button
                type="default"
                size="small"
                v-for="citems in item.children"
                round
                :key="citems.id"
                @click="handleFilterClick(citems)"
                :class="
                  filterValue.includes(citems.id)
                    ? 'search-filter-form-item-active'
                    : 'search-filter-form-item'
                "
                :color="filterValue.includes(citems) ? '#E5FCFA' : '#F1F2F4'"
              >
                {{ citems.name }}
              </van-button>
            </div>
          </div>

          <div class="search-filter-btn-box">
            <van-button round @click="onReset(item.children, index)">
              重置
            </van-button>
            <van-button
              class="search-confirm-btn"
              round
              color="#03CBBF"
              @click="onConfirm(index)"
            >
              确认
            </van-button>
          </div>
        </van-dropdown-item>

        <van-dropdown-item title="筛选" ref="searchFilterFormItemsAll">
          <p slot="title">
            筛选
          </p>
          <div class="search-filter-form-all">
            <div v-for="(item, index) in filter" :key="item.id">
              <p class="search-filter-form-all-title">{{ item.name }}</p>
              <div class="search-filter-form-list">
                <van-button
                  type="default"
                  size="small"
                  round
                  @click="handleAllFilterClick(item.children, index)"
                  :class="
                    filterActionsActive(item)
                      ? 'search-filter-form-item-active'
                      : 'search-filter-form-item'
                  "
                  :color="
                    filterActionsActive(item)
                      ? '#E5FCFA'
                      : '#F1F2F4'
                  "
                >
                  全部
                </van-button>
                <van-button
                  type="default"
                  size="small"
                  v-for="citems in item.children"
                  round
                  :key="citems.id"
                  @click="handleFilterClick(citems)"
                  :color="
                    filterActions(citems.id) ? '#E5FCFA' : '#F1F2F4'
                  "
                  :class="
                    filterActions(citems.id)
                      ? 'search-filter-form-item-active'
                      : 'search-filter-form-item'
                  "
                  >{{ citems.name }}</van-button
                >
              </div>
            </div>
          </div>

          <div class="search-filter-btn-box">
            <van-button round @click="onReset()">
              重置
            </van-button>
            <van-button
              class="search-confirm-btn"
              round
              color="#03CBBF"
              @click="onConfirm()"
            >
              确认
            </van-button>
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
    </van-sticky>
    <van-list
      ref="listRef"
      v-model="loading"
      :finished="total === 0 ? true : total === list.length"
      :finished-text="total > 0 ? '没有更多了' : ''"
      @load="fetch_more"
    >
      <div class="clinic-list-section" v-if="list.length > 0">
        <van-row
          class="clinic-list-section-box"
          @click="
            $router.push({ name: 'clinic-detail', params: { id: item.id } })
          "
          v-for="item in list"
          :key="item.id"
        >
          <div class="clinic-list-title">
            <span>招募</span>
            {{ item.id }}
            {{ item.title }}
          </div>
          <div class="clinic-list-tags">
            <van-tag
              color="#95E9DD"
              plain
              text-color="#08C0B5"
              v-for="val in item.tags_list"
              :key="val.id"
              size="medium"
              >{{ val.name }}</van-tag
            >
          </div>
          <div class="clinic-list-content">
            <div class="clinic-list-items">
              <div class="clinic-list-items-lable">项目描述</div>
              <div class="clinic-list-items-value">{{ item.desc }}</div>
            </div>
            <div class="clinic-list-items" v-if="item.project_pi">
              <div class="clinic-list-items-lable">
                <span class="clinic-list-items-lable-span">项目描述</span>
                <span class="clinic-list-items-lable-span2">项目PI</span>
              </div>
              <div class="clinic-list-items-value">
                {{ item.project_pi || "--" }}
              </div>
            </div>
            <div class="clinic-list-items" v-if="item.deal_company">
              <div class="clinic-list-items-lable">实施单位</div>
              <div class="clinic-list-items-value">
                {{ item.deal_company || "--" }}
              </div>
            </div>
            <div class="clinic-list-items">
              <div class="clinic-list-items-lable">发布日期</div>
              <div class="clinic-list-items-value">
                {{ item.end_time || "--" }}
              </div>
            </div>
          </div>
        </van-row>
      </div>
      <div v-else>
        <div v-if="loading">
          <clinic-list-skeleton
            v-if="loading"
            style="margin-bottom: 100vh"
          ></clinic-list-skeleton>
        </div>
        <div v-else-if="keyword || filterValueConfirm.length">
          <van-empty image="/static/img/pic_blank_content.svg">
            <template slot="description">
              <div style="text-align: center">
                很抱歉，根据您当前的筛选条件，暂时没有合适的临床项目。您可以联系客服获取帮助
              </div>
              <div style="text-align: center;margin-top: 24px">
                <van-button
                  color="#0FB7AD"
                  round
                  size="small"
                  style="width: 120px"
                  @click="wxdialog = true"
                >
                  联系客服
                </van-button>
              </div>
            </template>
          </van-empty>
        </div>
        <van-empty v-else image="/static/img/pic_blank_content.svg">
          <template slot="description">
            <div style="text-align: center">博医同行持续更新中…</div>
            <div style="text-align: center;margin-top: 10px">
              先看看其他内容吧！
            </div>
            <div style="text-align: center;margin-top: 24px">
              <van-button
                color="#0FB7AD"
                round
                size="small"
                style="width: 120px"
                @click="$toHomePage"
              >
                返回首页
              </van-button>
            </div>
          </template>
        </van-empty>
      </div>
    </van-list>
    <van-dialog
      v-model="wxdialog"
      :show-cancel-button="false"
      :show-confirm-button="false"
      confirm-button-text="微信沟通"
      @confirm="goWechat"
      cancel-button-text="电话沟通"
      @cancel="goPhone"
    >
      <img
        class="wx-dialog-kf-header"
        src="/static/bytx/kf-popup_head.png"
        alt=""
      />
      <van-icon name="cross" class="close-btn" @click="wxdialog = false" />
      <p class="wx-dialog-kf-content">
        联系专属客服，有助于快速入组
      </p>
      <div class="wx-dialog-kf-btn">
        <van-button
          round
          icon="phone"
          @click="goPhone"
          plain
          color="#05C8BC"
          type="primary"
          >电话沟通</van-button
        >
        <van-button
          @click="goWechat"
          round
          icon="wechat"
          color="linear-gradient(180deg, #41D6D4 0%, #49E6C8 100%)"
          type="primary"
          >微信沟通</van-button
        >
      </div>
    </van-dialog>
  </div>
</template>
<script>
import Interface from "@/util/interface";
import clinicListSkeleton from "@/skeleton/articleListSkeleton";
import { LocationHref } from "@/util/common";

export default {
  name: "clinic-list",
  components: {
    "clinic-list-skeleton": clinicListSkeleton
  },
  data() {
    return {
      value: "",
      active: "",
      banners: [],
      recommend: [],
      list: [],
      column: [],
      loading: true,
      page: 1,
      total: 0,
      pageSize: 10,
      total_page: 1,
      record_id: 0,
      keyword: "",
      filter: [],
      filterValue: [],
      filterValueConfirm: [],
      wxdialog: false,
      kfData: {
        phone: "",
        help_link: "",
        qrcode: ""
      }
    };
  },
  methods: {
    fetch(scene) {
      if (scene === "category") {
        Interface.getData("get", Interface.category, {
          type: 7,
          pageSize: 1000
        }).then(res => {
          const list = res.data.list;
          this.filter = list;
        });
      } else if (scene === "clinic") {
        this.loading = true;
        this.scrollToTop();
        this.page = 1;
        let params = {
          page: this.page,
          pageSize: this.pageSize,
          category_id: this.filterValueConfirm.join(","),
          keywords: this.keyword
        };
        if (this.value != "") {
          params.title = this.value;
        }
        Interface.getData("get", Interface.clinic.list, params).then(res => {
          const {
            list,
            total_page,
            total,
            help_link,
            qrcode,
            phone
          } = res.data;
          if (list != null) {
            this.list = list;
            this.total_page = total_page;
            this.total = total;
          } else {
            this.list = [];
            this.total_page = 1;
            this.total = 0;
          }
          this.kfData = {
            help_link: help_link,
            qrcode: qrcode,
            phone: phone
          };
          this.loading = false;
        });
      }
    },
    fetch_more() {
      this.page += 1;
      this.loading = true;
      let params = {
        page: this.page,
        pageSize: 10,
        category_id: this.filterValueConfirm.join(","),
        keywords: this.keyword
      };
      Interface.getData("get", Interface.clinic.list, params).then(res => {
        this.list.push(...res.data.list);
        this.total_page = res.data.total_page;
        this.total = res.data.total;
        // setTimeout(() => {
        this.loading = false;
        // }, 300);
      });
    },
    onSearch() {
      this.page = 0;
      this.list = [];
      this.fetch_more();
    },
    handleFilterClick(items) {
      if (this.filterValue.includes(items.id)) {
        this.filterValue = this.filterValue.filter(item => item !== items.id);
      } else {
        this.filterValue = [...this.filterValue, items.id];
      }
    },
    onReset(row, index) {
      if (row) {
        const mapids = row.map(item => item.id);
        this.filterValue = this.filterValue.filter(
          item => !mapids.includes(item)
        );
        this.filterValueConfirm = JSON.parse(JSON.stringify(this.filterValue));
      } else {
        this.filterValue = [];
        this.filterValueConfirm = [];
      }
      if (index !== undefined) {
        this.$refs[`searchFilterFormItems`][index].toggle(false);
      } else {
        this.$refs["searchFilterFormItemsAll"].toggle(false);
      }
      this.fetch("clinic");
    },
    onConfirm(index) {
      this.filterValueConfirm = JSON.parse(JSON.stringify(this.filterValue));
      if (index !== undefined) {
        this.$refs["searchFilterFormItems"][index].toggle(false);
      } else {
        this.$refs["searchFilterFormItemsAll"].toggle(false);
      }
      this.fetch("clinic");
    },
    handleAllFilterClick(tree) {
      const arr = tree.map(item => item.id);
      this.filterValue = this.filterValue.filter(item => !arr.includes(item));
    },

    goWechat() {
      LocationHref(this.kfData.help_link);
    },
    goPhone() {
      window.location.href = `tel://${this.kfData.phone}`;
    },
    filterActionsActiveClass(dataTree) {
      var arr = [];
      for (var i = 0; i < dataTree.children.length; i++) {
        if (this.filterValue.indexOf(dataTree.children[i].id) !== -1) {
          arr.push(dataTree.children[i].id);
        }
      }
      return arr.length;
    },
    filterActions(id) {
      return this.filterValue.indexOf(id) !== -1;
    },

    filterActionsActive(dataTree) {
      var arr = [];
      for (var i = 0; i < dataTree.children.length; i++) {
        if (this.filterValue.indexOf(dataTree.children[i].id) !== -1) {
          arr.push(dataTree.children[i].id);
        }
      }
      return !arr.length;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    }
  },
  created() {
    // if (this.$route.query.category) {
    //   // this.category_index = +this.$route.query.category;
    //   this.$forceUpdate();
    // } else if (sessionStorage.getItem("category")) {
    //   // this.category_index = +sessionStorage.getItem("category");
    //   sessionStorage.removeItem("category");
    //   this.$forceUpdate();
    // }
    this.fetch("category");
    sessionStorage.removeItem("search_data");
    Interface.getShareInfo(
      this,
      "临床招募——博医同行",
      "",
      "为战友匹配最合适的临床试验"
    );
    Interface.getData("post", Interface.footprint, {
      id: 1,
      type: 73,
      content_type: 0,
      page_type: 4,
      source_type: 0,
      parent_id: 0,
      record_id: 0,
      title: "临床招募项目列表页"
    }).then(res => {
      if (res.code == 0) {
        this.record_id = res.data.record_id;
      }
    });
    Interface.CoFootPrint(16);
    this.fetch("clinic");
    this.wxdialog = true;
  },
  beforeRouteLeave(to, from, next) {
    if (this.record_id) {
      Interface.mFootPrint(
        1,
        73,
        0,
        4,
        0,
        0,
        this.record_id,
        "临床招募项目列表页"
      );
    }
    next();
  }
};
</script>
<style lang="scss" scoped>
.clinic-list {
  background: linear-gradient(0deg, #f6f7f8 85%, #fafbfc 100%);
  padding-bottom: env(safe-area-inset-bottom);
  /deep/ .van-sticky {
    width: 100%;
    // height: 120px;
    flex-shrink: 0;
    // background: linear-gradient(225deg, #ecfff000 49.58%, #ecfff080 119.62%),
    //   linear-gradient(26deg, #27e0cd00 43.97%, #27e0cd33 115.22%), #effbfb;
    background: linear-gradient(180deg, #d9f8f6 0%, #f2fbfa 100%);
  }

  /deep/ .van-dropdown-menu__bar {
    background-color: transparent;
    box-shadow: none;
    .van-dropdown-menu__item {
      flex: auto;
    }
    .van-dropdown-menu__title {
      font-size: 14px;
      color: #1a1c1f;
      &::after {
        border-color: transparent transparent #b0b2b6 #b0b2b6;
      }
    }
    .van-dropdown-menu__title--active {
      color: #08c0b5;
      &::after {
        border-color: transparent transparent #08c0b5 #08c0b5;
      }
    }
  }
  .clinic-list-section {
    padding: 0 12px;
  }
  .clinic-list-section-box {
    background-color: #fff;
    padding: 12px 10px;
    border-radius: 12px;
    margin-top: 8px;
    .clinic-list-title {
      color: #1a1c1f;
      font-size: 15px;
      font-weight: 500;
      line-height: 22px;
      span {
        background: #08c0b5;
        border-radius: 3px;
        font-size: 12px;
        color: #ffffff;
        padding: 3px 6px;
        margin-right: 4px;
      }
    }
    .clinic-list-tags {
      display: flex;
      margin-top: 6px;
      margin-bottom: 10px;
      flex-wrap: wrap;
      gap: 8px;
    }
    .clinic-list-content {
      padding: 9px 10px;
      border-radius: 6px;
      background: #f4fbfb;
    }
  }
  .van-search__content {
    background-color: #fff;
    width: 347px;
    height: 36px;
    flex-shrink: 0;
    border-radius: 18px;
    border: 1px solid #03cbbf;
    background: #fff;
    .van-field__body {
      height: 100%;
    }
    .van-field__left-icon .van-icon {
      line-height: 26px;
    }
  }
  .clinic-list-items {
    display: flex;
    margin-top: 8px;
    .clinic-list-items-lable {
      color: #90959d;
      flex-shrink: 0;
      font-size: 12px;
      padding-right: 12px;
      position: relative;
      .clinic-list-items-lable-span {
        visibility: hidden;
      }
      .clinic-list-items-lable-span2 {
        position: absolute;
        left: 0;
      }
    }
    .clinic-list-items-value {
      -ms-flex: 1;
      flex: 1;
      color: #60666c;
      font-size: 12px;
      line-height: 18px;
    }
  }
  /deep/ .van-popup {
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
  }
  .search-filter-form-all-title {
    padding: 12px 0;
    padding-left: 14px;
    color: #1a1c1f;
    font-weight: 500;
    line-height: 20px;
  }
  .search-filter-form-all {
    max-height: 50vh;
    overflow-y: auto;
  }

  .search-filter-form-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 0px 14px 12px 14px;
    .van-button {
      font-size: 13px !important;
      padding: 0 16px;
    }
  }
  .search-filter-form-item {
    color: #343638 !important;
  }
  .search-filter-form-item-active {
    color: #08c0b5 !important;
  }
  .search-filter-btn-box {
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 10px 0;
    border-top: 1px solid #f2f2f2;
    .van-button {
      width: 168px;
      height: 40px;
      font-size: 15px;
    }
    .van-button--default {
      color: #343638 !important;
    }
    .search-confirm-btn {
      color: #fff !important;
    }
  }

  .van-dialog {
    background-color: transparent;
    /deep/ .van-dialog__content {
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0) 70px,
        #fff 80px,
        #fff 100%
      );

      .wx-dialog-kf-header {
        width: 100%;
      }

      .close-btn {
        position: absolute;
        right: 8px;
        top: 40px;
        font-size: 16px;
        background-color: #54c7cd;
        color: #fff;
        border-radius: 50%;
        padding: 4px;
      }
      .wx-dialog-kf-content {
        background-color: #fff;
        text-align: center;
        padding: 20px 0;
        color: #343638;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        margin-top: -28px;
        position: relative;
        z-index: 2;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        display: block;
      }
      .wx-dialog-kf-btn {
        padding-bottom: 20px;
        text-align: center;
        .van-button {
          width: 118px;
          height: 44px;
          margin: 0 5px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/clinic/list/index.vue